// OIDC client configuration for react-oidc-context (built on oidc-client-ts).
//
// `authority` points at the auth service's issuer (mounted under /api on
// the same origin, via the reverse proxy - see services/proxy). Passing
// only the authority is enough: oidc-client-ts fetches
// `${authority}/.well-known/openid-configuration` itself and uses whatever
// endpoints it reports (token_endpoint, jwks_uri, etc) - nothing else
// needs to be hard-coded here.
//
// Login/logout are both inline (see LoginForm.js / App.js's handleLogout)
// using oidc-client-ts purely for its *logic* - token requests, storage,
// decoding, and silent renewal - with no imposed UI:
//   - LOGIN calls `signinResourceOwnerCredentials({ username, password })`,
//     which POSTs directly to the token endpoint (grant_type=password,
//     see services/auth/src/grants/password.js). No browser redirect, no
//     separately hosted page.
//   - LOGOUT calls `revokeTokens()` + `removeUser()`. There's no
//     browser session at the auth service to end for this grant (nothing
//     ever visited its authorization endpoint), so there's nothing to
//     redirect to - just revoke server-side and drop the tokens locally.
// There's deliberately no `redirect_uri`/`post_logout_redirect_uri` here:
// nothing in this app ever calls `signinRedirect`/`signinPopup`/
// `signoutRedirect`, so they'd be dead config.
export const oidcConfig = {
  authority: `${window.location.origin}/api`,
  client_id: 'web',
  // offline_access gets us a refresh token so automatic silent renewal
  // (below) can use it directly instead of needing a silent-renew iframe
  // (which would require a browser session at the auth service that this
  // flow never creates).
  scope: 'openid profile offline_access',
  automaticSilentRenew: true,
  // Belt-and-suspenders: fetch /api/me (the userinfo_endpoint) for the
  // profile claims too, in case they aren't already in the ID token.
  loadUserInfo: true,
};
